setTimeout(()=>{BSS_B2B.redirect_url="/pages/takk"},4000);
let timeBack = 10;
const handleF = () => {
  const target = $(".options-selection__input-select");  
  if (target.length > 0) {
    $(target).on("change", () => {
      setTimeout(() => {
          const urlParams = new URLSearchParams(new URL(window.location.href).search);
          const variantValue = urlParams.get('variant');
          console.log(variantValue);
          BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), "[bss-b2b-variant-id]", false, false, variantValue);
      }, 200)
    })
  }
  else if (timeBack-- > 0) setTimeout(handleF, 300);
}
handleF();
// const fixSpam = () => {
//   $('[name="checkout"]').on("click",(e) => {
//     $(e.target).attr("disabled", "disabled")
//   })
// }

// document.addEventListener('DOMContentLoaded', function () {
//            fixSpam();    
// });

if(window.location.pathname.includes("/cart")) {
  setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
  }, 1000);
}

if(typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

//fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000); 
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
  
}
